import { Component, Input, OnChanges, SimpleChanges, HostBinding } from '@angular/core';

@Component({
	selector: 'portals-button-icon',
	templateUrl: './button-icon.component.html',
	styleUrls: ['./button-icon.component.scss'],
})
export class ButtonIconComponent {
	@Input() iconName: string = 'cancel';
	@Input() btnSize: number = 20;
	@Input() color: string = '';
	@HostBinding('style.--btnSize')
	get size() {
		return `${this.btnSize}px`;
	}
	@Input() onClick: () => void = () => {};

	handleOnClick() {
		this.onClick();
	}
}
